import React, { Component } from "react";
import { Link } from "react-router-dom";

class GeneralStatistics extends Component {
  addingClass() {
    document.getElementById("div").className += " active";
  }

  render() {
    return (
      <div>
        <ul className="nav nav-primary">
          <li className="nav-item submenu" id="div">
            <a
              data-toggle="collapse"
              href="#statistics"
              className="collapsed"
              aria-expanded="false"
              onClick={this.addingClass.bind(this)}
            >
              <i className="fas fa-chart-line"></i>
              <p>Estadísticas</p>
              <span className="caret"></span>
            </a>
            <div className="collapse" id="statistics">
              <ul className="nav nav-collapse">
                <li>
                  <Link to="/analityc">
                    <span className="sub-item">De uso</span>
                  </Link>
                </li>
                <li>
                  <Link to="/analitycmedic">
                    <span className="sub-item">De expediente</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default GeneralStatistics;
